import * as actionTypes from './actionTypes';
import { serviceMyPackageAvailable } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { fetchValidate } from '@app/src/common/session';

const fetchMyPackageAvailableRequest = () => ({
  type: actionTypes.FETCH_MY_PACKAGE_AVAILABLE_REQUEST
});

const fetchMyPackageAvailableSuccess = (data) => ({
  type: actionTypes.FETCH_MY_PACKAGE_AVAILABLE_SUCCESS,
  data
});

const fetchMyPackageAvailableFailure = () => ({
  type: actionTypes.FETCH_MY_PACKAGE_AVAILABLE_FAILURE
});

export const setMyPackageAvailableAll = (data: any) => ({
  type: actionTypes.SET_MY_PACKAGE_AVAILABLE_ALL,
  data
});

export const setMyPackageAvailableByChannel = (id: number, value: number) => ({
  type: actionTypes.SET_MY_PACKAGE_AVAILABLE_BY_CHANNEL,
  id,
  value
});

export const setMyPackageAvailableTotal = (value: number) => ({
  type: actionTypes.SET_MY_PACKAGE_AVAILABLE_TOTAL,
  value
});

export const clearMyPackageAvailableAll = () => ({
  type: actionTypes.CLEAR_MY_PACKAGE_AVAILABLE_ALL
});

export const setMyPackageAvailableBothById = (id: number, quantity: string) => ({
  type: actionTypes.SET_MY_PACKAGE_AVAILABLE_BOTH,
  id,
  quantity
});

export const fetchMyPackageAvailable = (userId: number, categoryId: number, packageId: number): Function => {
  return async dispatch => {
    dispatch(fetchMyPackageAvailableRequest());
    await dispatch(fetchValidate());
    try {
      const data = await serviceMyPackageAvailable.get(userId, categoryId, packageId);
      if (data && data.error) {
        dispatch(actionsModalError.openModalError(data && data.message));
      } else {
        dispatch(fetchMyPackageAvailableSuccess(data && data.data && data.data[0]));
      }
    } catch (e) {
      dispatch(fetchMyPackageAvailableFailure());
      dispatch(actionsModalError.openModalError());
      console.log('Error from fetch My Package Available', e);
      throw new Error(e);
    }
  }
};